import { UserRole } from '../../../shared/enums';

import PermissionsOfAddEditAccount from './permissionsOfAddEditAccount';
import PermissionsOfConfirmWriterAvailability from './permissionsOfConfirmWriterAvailability';
import PermissionsOfCoverCreator from './permissionsOfCoverCreator';
import PermissionsOfInterviews from './permissionsOfInterviews';
import PermissionsOfMyAccount from './permissionsOfMyAccount';
import PermissionsOfPhotosPage from './permissionsOfPhotosPage';
import PermissionsOfProfile from './permissionsOfProfile';
import PermissionsOfProjectDetails from './permissionsOfProjectDetails';
import PermissionsOfQuillChaptersEditor from './permissionsOfQuillChaptersEditor';
import PermissionsOfQuillCommentBox from './permissionsOfQuillCommentBox';
import PermissionsOfViewProof from './permissionsOfViewProof';
import PermissionsOfPackagePrices from './permissionsOfPackagePrices';
import permissionsOfAllAccounts from './permissionsOfAllAccounts';

const CommonPermissions = {
  SeeChatBotInfoModal: [UserRole.WRITER, UserRole.CUSTOMER],
};

const AllPermissions = {
  ...CommonPermissions,
  ...PermissionsOfAddEditAccount,
  ...PermissionsOfConfirmWriterAvailability,
  ...PermissionsOfCoverCreator,
  ...PermissionsOfInterviews,
  ...PermissionsOfMyAccount,
  ...PermissionsOfPhotosPage,
  ...PermissionsOfProfile,
  ...PermissionsOfProjectDetails,
  ...PermissionsOfQuillChaptersEditor,
  ...PermissionsOfQuillCommentBox,
  ...PermissionsOfViewProof,
  ...PermissionsOfPackagePrices,
  ...permissionsOfAllAccounts,
};

export default AllPermissions;
